/** Full-width card: portrait below `lg` (aligns with Keep Going); wider ratio at `lg+` so the row isn’t excessively tall. */
export const SUGGESTED_SERIES_ASPECT_CLASS = 'aspect-[9/10] lg:aspect-[2.84]'
